// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"1f2e0d97","285":"3d233215","287":"f43328b6","345":"bd25f568","453":"617e65e8","492":"9b38238c","588":"7268157a","671":"3cd209d8","686":"f27f359a","772":"6fdfe63a","829":"5bd41b13","849":"c5e07ad6","864":"c8ee57b1","880":"1c421d20","928":"f1133740"}[chunkId] + ".chunk.js";
};